import { render, staticRenderFns } from "./homeProfileReview.component.vue?vue&type=template&id=7a394294&scoped=true&"
import script from "./homeProfileReview.component.vue?vue&type=script&lang=js&"
export * from "./homeProfileReview.component.vue?vue&type=script&lang=js&"
import style0 from "./homeProfileReview.component.vue?vue&type=style&index=0&id=7a394294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a394294",
  null
  
)

export default component.exports